export const ServicioObjetos = {

    esObjetoVacio(objeto) {     
        if (objeto === undefined)
          return true;
          
        if (objeto === null)
          return true;
          
        if (objeto.length > 0)      
          return false;
          
        if (objeto.length === 0)
          return true;
              
        if (objeto === true)
          return false;    
          
        if (Object.keys(objeto).length > 0)
          return false;
        
    
        if (JSON.stringify(objeto) === JSON.stringify({}))
          return true;
          
        for (var key in objeto) {
          if (hasOwnProperty.call(objeto, key))
            return false;              
        }
        if (typeof objeto === 'number')
          return false;
              
        if (JSON.stringify(objeto).length > 0)
            return false; 
        return true;
      }
}